import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Tabs, Button, Modal, Input, Select, DatePicker, message } from "antd";
import Table from "../../../Componets/Table";
import headers from "../../../Data/Tables/Receipt/headers";
import tables from "../../../Data/Tables/Receipt/tables";
import { PrinterOutlined, DollarOutlined } from "@ant-design/icons";
import Header from "../../../Componets/Header";
import Loadercomponent from "../../../Componets/Loader";
import toast from "react-hot-toast";
import { get_unpaid_invoices } from "../../../Controllers/Sales/Invoices";
import { get_unpaid_purchase_orders } from "../../../Controllers/Purchases/Orders";
import {
  process_payment,
  get_payment_receipt,
} from "../../../Controllers/Receipt";
import dayjs from "dayjs";
import { useReactToPrint } from "react-to-print";
import moment from "moment";

const PaymentsDashboard = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [activeTab, setActiveTab] = useState("invoices");
  const [invoices, setInvoices] = useState([]);
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [paymentModal, setPaymentModal] = useState({
    visible: false,
    data: null,
    type: null,
  });
  const [paymentAmount, setPaymentAmount] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("Cash");
  const [paymentReference, setPaymentReference] = useState("");
  const [paymentDate, setPaymentDate] = useState(dayjs());
  const [processingPayment, setProcessingPayment] = useState(false);
  const [header, setHeader] = useState(headers);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });
  const receiptRef = React.useRef();

  const paginationdata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
    });
  };

  const paymentMethods = [
    { value: "Cash", label: "Cash" },
    { value: "Bank Transfer", label: "Bank Transfer" },
    { value: "Cheque", label: "Cheque" },
    { value: "Credit Card", label: "Credit Card" },
    { value: "Debit Card", label: "Debit Card" },
    { value: "Online Payment", label: "Online Payment" },
  ];

  const fetchData = async () => {
    setLoader(true);
    try {
      if (activeTab === "invoices") {
        const response = await get_unpaid_invoices({ payment_status: [0, 1] });
        if (response?.status) {
          let data = [];

          console.log("ahiokajsd", response)

          response?.data?.map((value, index) => {
            data?.push({
              Invoice: "#INV-" + value?.number,
              Customer: value?.customer?.name ? value?.customer?.name : "Walk - IN",
              Date: moment(value?.date).format("MMMM Do YYYY"),
              "Due Date": value?.due_date
                ? moment(value?.due_date).format("MMMM Do YYYY")
                : "-",
              Total: value?.total?.toFixed(3),
              Paid: value?.paid?.toFixed(3),
              Remaining: value?.remaining?.toFixed(3),
              "Payment Status":
                value?.payment_status == 2 ? (
                  <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
                    Paid
                  </span>
                ) : value?.payment_status == 1 ? (
                  <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
                    Partial
                  </span>
                ) : (
                  <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
                    Unpaid
                  </span>
                ),
              Action: (
                <Button
                  type="primary"
                  onClick={() => openPaymentModal(value, "invoice")}
                  size="small"
                >
                  Pay
                </Button>
              ),
            });
          });

          setPagination({
            currentPage: response?.data?.currentPage,
            totalCount: response?.data?.totalCount,
            totalPages: response?.data?.totalPages,
          });

          setInvoices(data);
        }
      } else {
        const response = await get_unpaid_purchase_orders({
          payment_status: [0, 1],
        });
        if (response?.status) {
          let data = [];

          response?.data?.map((value, index) => {
            data?.push({
              PO: "#PO-" + value?.number,
              Supplier: value?.supplier?.name,
              Date: moment(value?.date).format("MMMM Do YYYY"),
              "Due Date": value?.due_date
                ? moment(value?.due_date).format("MMMM Do YYYY")
                : "-",
              Total: value?.total?.toFixed(3),
              Paid: value?.paid?.toFixed(3),
              Remaining: value?.remaining?.toFixed(3),
              "Payment Status":
                value?.payment_status == 2 ? (
                  <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
                    Paid
                  </span>
                ) : value?.payment_status == 1 ? (
                  <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
                    Partial
                  </span>
                ) : (
                  <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
                    Unpaid
                  </span>
                ),
              Action: (
                <Button
                  type="primary"
                  onClick={() => openPaymentModal(value, "purchase")}
                  size="small"
                >
                  Pay
                </Button>
              ),
            });
          });

          setPagination({
            currentPage: response?.data?.currentPage,
            totalCount: response?.data?.totalCount,
            totalPages: response?.data?.totalPages,
          });

          setPurchaseOrders(data);
        }
      }
    } catch (error) {
      toast.error("Failed to fetch data");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [activeTab]);

  const openPaymentModal = (record, type) => {
    setPaymentModal({
      visible: true,
      data: record,
      type: type,
    });
    setPaymentAmount(record.remaining?.toFixed(3) || record.total?.toFixed(3));
    setPaymentMethod("Cash");
    setPaymentReference("");
    setPaymentDate(dayjs());
  };

  const handlePaymentSubmit = async () => {
    if (!paymentAmount || parseFloat(paymentAmount) <= 0) {
      toast.error("Please enter a valid amount");
      return;
    }

    const remaining =
      paymentModal.type === "invoice"
        ? paymentModal.data.remaining
        : paymentModal.data.remaining;

    if (parseFloat(paymentAmount) > parseFloat(remaining)) {
      toast.error(`Amount cannot exceed remaining balance of ${remaining}`);
      return;
    }

    setProcessingPayment(true);
    try {
      const payload = {
        document_id: paymentModal.data._id,
        document_type: paymentModal.type,
        amount: parseFloat(paymentAmount),
        payment_method: paymentMethod,
        reference: paymentReference,
        payment_date: paymentDate.toISOString(),
        customer:
          paymentModal.type === "invoice"
            ? paymentModal.data.customer?._id
            : null,
        supplier:
          paymentModal.type === "purchase"
            ? paymentModal.data.supplier?._id
            : null,
      };

      const response = await process_payment(payload);

      if (response?.status) {
        toast.success("Payment processed successfully");
        setPaymentModal({ visible: false, data: null, type: null });
        fetchData();

        if (response.receipt) {
          showReceipt(response.receipt);
        }
      } else {
        toast.error(response?.message || "Payment failed");
      }
    } catch (error) {
      toast.error("Payment processing failed");
    } finally {
      setProcessingPayment(false);
    }
  };

  const showReceipt = (receiptData) => {
    Modal.info({
      title: "Payment Receipt",
      width: 600,
      content: (
        <div ref={receiptRef} className="p-4">
          <div className="text-center mb-4">
            <h2 className="text-xl font-bold">PAYMENT RECEIPT</h2>
            <p>Receipt No: {receiptData.receipt_number}</p>
            <p>Date: {dayjs(receiptData.date).format("DD/MM/YYYY HH:mm")}</p>
          </div>
          <div className="mb-4">
            <p>
              <strong>
                {receiptData.document_type === "invoice"
                  ? "Customer"
                  : "Supplier"}
                :
              </strong>{" "}
              {receiptData.party_name}
            </p>
            <p>
              <strong>
                {receiptData.document_type === "invoice"
                  ? "Invoice"
                  : "Purchase Order"}{" "}
                No:
              </strong>{" "}
              {receiptData.document_number}
            </p>
          </div>
          <div className="mb-4">
            <p>
              <strong>Payment Method:</strong> {receiptData.payment_method}
            </p>
            <p>
              <strong>Reference:</strong> {receiptData.reference || "N/A"}
            </p>
          </div>
          <div className="border-t border-b py-4 my-4">
            <div className="flex justify-between">
              <span>
                <strong>Amount Paid:</strong>
              </span>
              <span className="text-lg font-bold">
                OMR {receiptData.amount?.toFixed(3)}
              </span>
            </div>
            <div className="flex justify-between mt-2">
              <span>
                <strong>Previous Balance:</strong>
              </span>
              <span>OMR {receiptData.previous_balance?.toFixed(3)}</span>
            </div>
            <div className="flex justify-between mt-2">
              <span>
                <strong>Current Balance:</strong>
              </span>
              <span>OMR {receiptData.current_balance?.toFixed(3)}</span>
            </div>
          </div>
          <div className="text-center text-sm text-gray-500 mt-4">
            <p>Thank you for your payment!</p>
          </div>
        </div>
      ),
      okText: "Print Receipt",
      onOk: () => {
        const printWindow = window.open("", "_blank");
        printWindow.document.write(`
          <html>
            <head>
              <title>Payment Receipt</title>
              <style>
                body { font-family: Arial, sans-serif; padding: 20px; }
                .receipt { max-width: 400px; margin: 0 auto; }
                .text-center { text-align: center; }
                .border-t { border-top: 1px solid #ddd; }
                .border-b { border-bottom: 1px solid #ddd; }
                .flex { display: flex; }
                .justify-between { justify-content: space-between; }
                .mt-2 { margin-top: 8px; }
                .mt-4 { margin-top: 16px; }
                .mb-4 { margin-bottom: 16px; }
                .py-4 { padding-top: 16px; padding-bottom: 16px; }
                .my-4 { margin-top: 16px; margin-bottom: 16px; }
              </style>
            </head>
            <body>
              <div class="receipt">
                ${document.querySelector(".ant-modal-body").innerHTML}
              </div>
            </body>
          </html>
        `);
        printWindow.print();
        printWindow.close();
      },
    });
  };

  const invoiceColumns = [
    {
      name: "Invoice",
    },
    {
      name: "Customer",
    },
    {
      name: "Date",
    },
    {
      name: "Due Date",
    },
    {
      name: "Total",
    },
    {
      name: "Paid",
    },
    {
      name: "Remaining",
    },
    {
      name: "Payment Status",
    },
    {
      name: "Action",
    },
  ];

  const purchaseColumns = [
    {
      name: "PO",
    },
    {
      name: "Supplier",
    },
    {
      name: "Date",
    },
    {
      name: "Due Date",
    },
    {
      name: "Total",
    },
    {
      name: "Paid",
    },
    {
      name: "Remaining",
    },
    {
      name: "Payment Status",
    },
    {
      name: "Action",
    },
  ];

  const tabItems = [
    {
      key: "invoices",
      label: "Unpaid Invoices",
      children: (
        <Table
          head={invoiceColumns}
          body={invoices}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      ),
    },
    {
      key: "purchase",
      label: "Unpaid Purchase Orders",
      children: (
        <Table
          head={purchaseColumns}
          body={purchaseOrders}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      ),
    },
  ];

  return (
    <Header headers={header} setHeaders={setHeader}>
      <Loadercomponent loader={loader}>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={tabItems}
          className="p-4"
        />
        <Modal
          title={`Make Payment - ${paymentModal.type === "invoice" ? "Invoice" : "Purchase Order"}`}
          open={paymentModal.visible}
          onCancel={() =>
            setPaymentModal({ visible: false, data: null, type: null })
          }
          footer={[
            <Button
              key="cancel"
              onClick={() =>
                setPaymentModal({ visible: false, data: null, type: null })
              }
            >
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={processingPayment}
              onClick={handlePaymentSubmit}
            >
              Process Payment
            </Button>,
          ]}
          width={500}
        >
          {paymentModal.data && (
            <div className="space-y-4">
              <div className="bg-gray-50 p-3 rounded">
                <p>
                  <strong>Document #:</strong>{" "}
                  {paymentModal.type === "invoice"
                    ? `#INV-${paymentModal.data.number}`
                    : `#PO-${paymentModal.data.number}`}
                </p>
                <p>
                  <strong>
                    {paymentModal.type === "invoice" ? "Customer" : "Supplier"}:
                  </strong>{" "}
                  {paymentModal.type === "invoice"
                    ? paymentModal.data.customer?.name ? paymentModal.data.customer?.name : "Walk - In"
                    : paymentModal.data.supplier?.name}
                </p>
                <p>
                  <strong>Total Amount:</strong> OMR{" "}
                  {paymentModal.data.total?.toFixed(3)}
                </p>
                <p>
                  <strong>Already Paid:</strong> OMR{" "}
                  {paymentModal.data.paid?.toFixed(3)}
                </p>
                <p>
                  <strong>Remaining:</strong> OMR{" "}
                  {paymentModal.data.remaining?.toFixed(3)}
                </p>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Payment Amount *
                </label>
                <Input
                  type="number"
                  value={paymentAmount}
                  onChange={(e) => setPaymentAmount(e.target.value)}
                  placeholder="Enter amount"
                  prefix="OMR"
                  step="0.001"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Payment Method *
                </label>
                <Select
                  className="w-full"
                  options={paymentMethods}
                  value={paymentMethod}
                  onChange={setPaymentMethod}
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Reference
                </label>
                <Input
                  value={paymentReference}
                  onChange={(e) => setPaymentReference(e.target.value)}
                  placeholder="Enter reference"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Payment Date
                </label>
                <DatePicker
                  className="w-full"
                  value={paymentDate}
                  onChange={setPaymentDate}
                  format="DD/MM/YYYY"
                />
              </div>
            </div>
          )}
        </Modal>
      </Loadercomponent>
    </Header>
  );
};

export default PaymentsDashboard;
